var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "48px",
    height: "px",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(9.803922%,46.666667%,95.294118%)",
      fillOpacity: 1
    },
    d: "M 48 24.003906 C 48 37.257812 37.253906 48.003906 24 48.003906 C 10.746094 48.003906 0 37.257812 0 24.003906 C 0 10.75 10.746094 0.00390625 24 0.00390625 C 37.253906 0.00390625 48 10.75 48 24.003906 Z M 48 24.003906 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 33.34375 30.941406 L 34.40625 24.003906 L 27.75 24.003906 L 27.75 19.5 C 27.75 17.605469 28.679688 15.75 31.660156 15.75 L 34.6875 15.75 L 34.6875 9.84375 C 34.6875 9.84375 31.941406 9.375 29.316406 9.375 C 23.835938 9.375 20.25 12.695312 20.25 18.714844 L 20.25 24.003906 L 14.15625 24.003906 L 14.15625 30.941406 L 20.25 30.941406 L 20.25 47.714844 C 21.472656 47.90625 22.722656 48.003906 24 48.003906 C 25.277344 48.003906 26.527344 47.902344 27.75 47.714844 L 27.75 30.941406 Z M 33.34375 30.941406 "
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.452779f3.svg";
export { ForwardRef as ReactComponent };